export default "__VITE_ASSET__e2683870__"